<template>
  <v-app :class="[largeFont ? 'large-font-size' : 'normal-font-size']">
    <div v-show="isBusy" class="text-center ma-auto">
      <loading
        :active.sync="isBusy"
        color="grey"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>

    <div
      id="app-main"
      v-show="!isBusy"
      :class="hasError ? 'disabled-content' : ''"
    >
      <div
        v-if="page !== pages.KioskLanding && !offline"
        :class="[largeFont ? 'large-font-size' : 'normal-font-size']"
      >
        <app-header v-show="displayHeader"></app-header>
        <app-main-container
          :page="page"
          :language="selectedLanguage"
        ></app-main-container>
      </div>
      <div v-else-if="offline" class="background">
        <div class="offline">
          <p>{{ siteText.ui.temporarilyOffline }}</p>
        </div>
      </div>
      <div v-else>
        <app-kiosk-landing></app-kiosk-landing>
      </div>
    </div>

    <app-error
      v-if="!offline"
      :error="error"
      @refresh="reloadApp()"
      @close="clearError()"
    ></app-error>
  </v-app>
</template>

<script>
const UNIQUE_ID_PARAMETER = "u";
const SERIAL_NUMBER_PARAMTER = "serialnumber";

import "./assets/css/app.css";
import { mapGetters, mapActions } from "vuex";

import appError from "./components/ui/Error.vue";
import loading from "vue-loading-overlay";
import appHeader from "./components/Header.vue";
import appMainContainer from "./components/MainContainer.vue";
import appKioskLanding from "./pages/KioskLanding.vue";
import offlineChecker from "./js/offlineChecker";
import updateChecker from "./js/updateChecker";

export default {
  name: "App",
  components: {
    loading,
    appHeader,
    appMainContainer,
    appKioskLanding,
    appError,
  },
  data() {
    return {
      offline: false,
    };
  },
  methods: {
    ...mapActions([
      "SetPage",
      "kioskSetSerialNumber",
      "initializeSessionData",
      "setUniqueId",
      "setSystemError",
      "clearSession",
      "getSettings",
    ]),
    async determineStartPage() {
      const serialNumber = this.getUrlParameter(SERIAL_NUMBER_PARAMTER);
      const uniqueId = this.getUrlParameter(UNIQUE_ID_PARAMETER);

      this.kioskSetSerialNumber(serialNumber || "");

      let startPage = this.pages.KioskLanding.name;

      if (!serialNumber) {
        startPage = this.pages.TokenLogin.name;
        this.setUniqueId(uniqueId || "");
      } else {
        this.startBackgroundProcesses();
      }
      //Uncomment for testing
      //startPage = this.pages.TestPage.name;
      this.SetPage(startPage);
    },
    reloadApp() {
      window.location.reload();
    },
    clearError() {
      this.setSystemError("");
    },
    async startBackgroundProcesses() {
      await this.getSettings();
      updateChecker.stopUpdateCheck();
      updateChecker.startUpdateCheck(
        this.updateCheckInterval,
        this.siteVersion,
        this.onUpdateCheckerCheck
      );
      const _this = this;
      offlineChecker.startOnlineCheck(function(status) {
        if (!status) {
          _this.offline = true;
        } else {
          _this.clearSessionReload();
        }
      });
    },
    clearSessionReload() {
      //clear session//
      this.clearSession();
      window.location.reload(true);
    },
    onUpdateCheckerCheck(status) {
      if (this.page === this.pages.KioskLanding) {
        if (status.frontEndVersion !== this.siteVersion) {
          this.clearSessionReload();
        } else {
          //just update settings//
          console.log("Updating settings.");
          this.getSettings(true);
        }
      }
    },
    validateUrlParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const validParameters = process.env.VUE_APP_VALID_PARAMETERS;
      let hasInvalidParameters = false;
      console.log(window.location.search);
      console.log(urlParams);
      let cleanUrl = window.location.href;
      for (let p of urlParams.entries()) {
        console.log(p);
        if (!validParameters.includes(p[0].toLowerCase())) {
          hasInvalidParameters = true;
          cleanUrl = this.removeURLParameter(cleanUrl, p[0]);
        }
      }

      if (hasInvalidParameters) {
        window.location.replace(cleanUrl);
      }
    },
    getUrlParameter(parameterName) {
      const urlParams = new URLSearchParams(window.location.search);
      let value = null;
      for (let p of urlParams.entries()) {
        if (p[0].toLowerCase() === parameterName) {
          value = p[1];
          break;
        }
      }
      return value;
    },
    removeURLParameter(url, parameter) {
      //prefer to use l.search if you have a location/link object
      var urlparts = url.split("?");
      if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + "=";
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0; ) {
          //idiom for string.startsWith
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            pars.splice(i, 1);
          }
        }

        return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
      }
      return url;
    },
  },
  async created() {},
  beforeMount() {
    this.validateUrlParameters();
    this.determineStartPage();
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "page",
      "pages",
      "selectedLanguage",
      "largeFont",
      "isBusy",
      "isKiosk",
      "siteText",
      "error",
      "updateCheckInterval",
      "siteVersion",
    ]),
    displayHeader() {
      return true;
    },
    hasError() {
      return this.error && this.error.message && this.error.message !== "";
    },
  },
};
</script>

<style>
@import "../node_modules/roboto-fontface/css/roboto/roboto-fontface.css";
html {
  overflow-y: auto !important;
}
</style>

<style scoped>
.background {
  background: url("./assets/images/kiosk_ktLanding_plain.png");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100%;
  height: 100vh;
  max-width: 100%;
}

.offline {
  transform-origin: center center;
}

.offline p {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  font-size: 80pt;
  text-transform: uppercase;
}

.cursor-hidden {
  cursor: none;
}

.disabled-content {
  pointer-events: none !important;
  cursor: none !important;
}
</style>
